import clsx from 'clsx';
import { Stack } from 'components';

import style from './mpiIndicators.module.scss';

type MpiIndicatorItemProps = {
  label: string;
  completed: boolean;
};

const MpiIndicatorItem = ({ label, completed }: MpiIndicatorItemProps) => (
  <Stack direction="row" alignItems="center" gap="4px">
    <span
      className={clsx(
        style.indicator,
        completed ? style.indicatorComplete : style.indicatorIncomplete
      )}
    >
      {completed ? <span className="material-icons">check</span> : null}
    </span>
    <span className={style.indicatorLabel}>{label}</span>
  </Stack>
);

type MpiIndicatorsProps = {
  note: boolean;
  screener: boolean;
  snapshot: boolean;
};

export const MpiIndicators = ({ note, screener, snapshot }: MpiIndicatorsProps) => (
  <Stack alignItems="center" gap="4px" marginTop="16px">
    <p className={style.mpiTitle}>MPI:</p>
    <Stack flexDirection="row" gap="12px">
      <MpiIndicatorItem label="Note" completed={note} />
      <MpiIndicatorItem label="Screener" completed={screener} />
      <MpiIndicatorItem label="Snapshot" completed={snapshot} />
    </Stack>
  </Stack>
);
